import { render, staticRenderFns } from "./RAlertCard.vue?vue&type=template&id=74626ae6&scoped=true&"
import script from "./RAlertCard.vue?vue&type=script&lang=js&"
export * from "./RAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./RAlertCard.vue?vue&type=style&index=0&id=74626ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74626ae6",
  null
  
)

export default component.exports